module.exports = __webpack_public_path__ + "img/buddy_antenna-01.678c55ae.svg";